// Meta Pixel utility — Pixel ID: 950194048186409

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  try {
    // Set up fbq queue before script loads
    const n: any = (window.fbq = function () {
      // @ts-ignore
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = [] as any[]

    // Load the fbevents.js script safely
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    // Initialize pixel
    window.fbq('init', '950194048186409')
  } catch (e) {
    console.warn('Meta Pixel failed to initialize:', e)
  }
}

export function trackPageView() {
  try {
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  } catch (e) {
    console.warn('Meta Pixel PageView tracking failed:', e)
  }
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart')
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart tracking failed:', e)
  }
}
